import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, TrendingUpIcon } from 'lucide-react';
const START_SECONDS = 30 * 60; // 30 minutes
const START_PROGRESS = 77;
const format = (totalSeconds: number) => {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return {
    m: String(m).padStart(2, '0'),
    s: String(s).padStart(2, '0')
  };
};
export function UrgencyBanner() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  const [progress, setProgress] = useState(START_PROGRESS);
  const tickRef = useRef(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
      // Slowly creep the progress bar up to build urgency, capped at 94%
      tickRef.current += 1;
      if (tickRef.current % 7 === 0) {
        setProgress(prev => prev < 94 ? +(prev + 0.4).toFixed(1) : prev);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const {
    m,
    s
  } = format(seconds);
  return <div className="max-w-3xl mx-auto mb-5" data-id="element-251">
      <div className="relative overflow-hidden rounded-2xl bg-red-600 text-white shadow-xl border border-red-400/40" data-id="element-252">
        {/* Animated glow */}
        <motion.div aria-hidden className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent" initial={{
        x: '-120%'
      }} animate={{
        x: '120%'
      }} transition={{
        duration: 2.4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-253" />

        <div className="relative p-3 md:p-4" data-id="element-254">
          {/* Top row: alert + timer */}
          <div className="flex items-center justify-between gap-3" data-id="element-255">
            <div className="flex items-center gap-2 min-w-0" data-id="element-256">
              <motion.span animate={{
              scale: [1, 1.18, 1]
            }} transition={{
              duration: 1,
              repeat: Infinity
            }} className="flex-shrink-0" data-id="element-257">
                <FlameIcon size={22} className="text-brand-goldlight" data-id="element-258" />
              </motion.span>
              <p className="text-[11px] md:text-sm font-extrabold uppercase tracking-wide leading-tight" data-id="element-259">
                ¡Última oportunidad a este precio!
              </p>
            </div>

            <div className="flex items-center gap-1 flex-shrink-0 bg-black/25 rounded-lg px-2 py-1 font-mono font-bold tabular-nums" data-id="element-260">
              <span className="text-lg md:text-2xl" data-id="element-261">{m}</span>
              <span className="text-lg md:text-2xl animate-pulse" data-id="element-262">:</span>
              <span className="text-lg md:text-2xl" data-id="element-263">{s}</span>
            </div>
          </div>

          {/* Message */}
          <p className="text-[11px] md:text-sm font-medium text-white/95 mt-2 flex items-center gap-1.5 leading-snug" data-id="element-264">
            <TrendingUpIcon size={14} className="text-brand-goldlight flex-shrink-0" data-id="element-265" />
            Cuando se agoten los cupos, el precio sube{' '}
            <span className="font-extrabold text-brand-goldlight" data-id="element-266">
              +$10.000
            </span>{' '}
            y no vuelve a bajar.
          </p>

          {/* Progress bar */}
          <div className="mt-2.5" data-id="element-267">
            <div className="h-2.5 w-full rounded-full bg-black/25 overflow-hidden" data-id="element-268">
              <motion.div className="h-full rounded-full bg-brand-goldlight" initial={{
              width: `${START_PROGRESS}%`
            }} animate={{
              width: `${progress}%`
            }} transition={{
              duration: 0.6,
              ease: 'easeOut'
            }} data-id="element-269" />
            </div>
            <p className="text-[10px] md:text-xs font-bold mt-1 text-white/90" data-id="element-270">
              {Math.round(progress)}% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>
    </div>;
}